import React from 'react'

import HeroBase from './HeroBase'
import CatalogSearch from './CatalogSearch'

const HeroCatalog = () => (
    <HeroBase>
        <h1 className="hero__title h1 hero--center">Intent Catalog</h1>
        <div className="hero__search">
            <CatalogSearch
                placeholder="Search for intents, models and APIs"
                extraLight
            />
        </div>
    </HeroBase>
)

export default HeroCatalog



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/HeroCatalog.jsx